export default "__VITE_ASSET__CkMb9NxL__"